import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "../../lib/api";

export const ReviewBox = ({ c, onDone }) => {
  const [note, setNote] = useState("");
  const go = () => api.post(`/admin/wellness/${c.id}/review`, { note: note || null }).then(() => { toast.success("Marcado como revisado"); onDone(); }).catch((e) => toast.error(formatErr(e)));
  return (
    <div style={{ display: "flex", gap: 6, marginTop: 6, flexWrap: "wrap" }} data-testid={`wb-review-${c.id}`}>
      <input className="qv-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Nota interna (opcional)" style={{ flex: 1, minWidth: 180, textTransform: "none", padding: "6px 8px", fontSize: 12 }} data-testid={`wb-review-note-${c.id}`} />
      <button className="qv-btn-primary" style={{ padding: "6px 12px", fontSize: 12 }} onClick={go} data-testid={`wb-review-done-${c.id}`}>Marcar revisado</button>
    </div>
  );
};
